// 盤面のタップ・なぞり操作（mch-dice の onBoardTap / onBoardDrag を移植）。
// チャットの入力中やモーダル表示中は盤面操作を受け付けない（誤発火防止）。
import { modalOpen } from '../ui/overlay';
import type { BoardView } from './render';

export interface InputHandlers {
  /** なぞり開始できるか（自分のヒーロー、または経路の終点を押したとき） */
  dragStart(cell: number): number[] | null;
  /** なぞりで1マス足す／戻す。受け付けたら新しい経路を返す */
  dragStep(path: number[], cell: number): number[] | null;
  dragEnd(path: number[], moved: boolean): void;
  tap(cell: number): void;
  key(key: string): boolean;
}

export const typingNow = () => {
  const a = document.activeElement as HTMLElement | null;
  return !!a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable);
};
const blocked = () => modalOpen() || typingNow();

export function bindBoardInput(view: BoardView, h: InputHandlers) {
  const cv = view.cv;
  let drag: { path: number[]; moved: boolean; start: number; id: number } | null = null;
  const cellOf = (e: PointerEvent) => {
    const r = cv.getBoundingClientRect();
    return view.cellAt(e.clientX - r.left, e.clientY - r.top);
  };
  const down = (e: PointerEvent) => {
    if (blocked() || (e.pointerType === 'mouse' && e.button !== 0)) return;
    const cell = cellOf(e);
    if (cell == null) return;
    const route = h.dragStart(cell);
    if (route) {
      drag = { path: route, moved: false, start: cell, id: e.pointerId };
      cv.setPointerCapture?.(e.pointerId);
      e.preventDefault();
      return;
    }
    h.tap(cell);
  };
  const move = (e: PointerEvent) => {
    if (!drag || e.pointerId !== drag.id) return;
    const cell = cellOf(e);
    if (cell == null || cell === drag.path[drag.path.length - 1]) return;
    const next = h.dragStep(drag.path, cell);
    if (!next) return;
    drag.path = next;
    drag.moved = true;
  };
  const up = (e: PointerEvent) => {
    if (!drag || e.pointerId !== drag.id) return;
    const d = drag;
    drag = null;
    if (d.moved) h.dragEnd(d.path, true);
    else h.tap(d.start);
  };
  const cancel = () => (drag = null);
  const key = (e: KeyboardEvent) => {
    if (blocked() || e.altKey || e.ctrlKey || e.metaKey) return;
    if (h.key(e.key)) e.preventDefault();
  };
  cv.addEventListener('pointerdown', down);
  cv.addEventListener('pointermove', move);
  window.addEventListener('pointerup', up);
  window.addEventListener('pointercancel', cancel);
  window.addEventListener('keydown', key);
  return () => {
    cv.removeEventListener('pointerdown', down);
    cv.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', up);
    window.removeEventListener('pointercancel', cancel);
    window.removeEventListener('keydown', key);
  };
}
